import localize from '../../../../common/localize';
import ReportSectionTitle from '../../../../components/common/ReportSectionTitle';
import InfoRowData from './InfoRowData';

export default function ReportClientData({ clientData }) {
  const valueOrNoData = (value) => {
    if (value && value.length > 0) {
      return value;
    }

    return localize.no_data;
  };

  const generateTableData = () => {
    const clientDataArray = [];

    clientDataArray.push({
      Id: 1,
      firstFieldName: `${localize.identification_type}:`,
      firstFieldValue: clientData?.Identification
        ? valueOrNoData(clientData?.IdentificationType)
        : localize.no_data,
      lastFieldName: `${localize.identification}:`,
      lastFieldValue: valueOrNoData(clientData?.Identification),
    });

    clientDataArray.push({
      Id: 2,
      firstFieldName: `${localize.name}:`,
      firstFieldValue: valueOrNoData(clientData?.Name),
      lastFieldName: `${localize.phone_number}:`,
      lastFieldValue: valueOrNoData(clientData?.PhoneNumber),
    });

    clientDataArray.push({
      Id: 3,
      firstFieldName: `${localize.email}:`,
      firstFieldValue: valueOrNoData(clientData?.Email),
      lastFieldName: `${localize.contact_name}:`,
      lastFieldValue: valueOrNoData(clientData?.ContactName),
    });

    clientDataArray.push({
      Id: 4,
      firstFieldName: `${localize.city}:`,
      firstFieldValue: valueOrNoData(clientData?.City?.Name),
      lastFieldName: `${localize.department}:`,
      lastFieldValue: valueOrNoData(clientData?.State?.Name),
    });

    clientDataArray.push({
      Id: 5,
      firstFieldName: `${localize.address}:`,
      firstFieldValue: valueOrNoData(clientData?.Address ? 
                                    `${clientData?.Address} ${clientData?.AddressComplement ?? ''}` 
                                    : clientData.AddressComplement),
    });

    return clientDataArray;
  };

  const generateRowData = (
    registerId,
    leftField,
    rightField,
    maxHeightValue
  ) => (
    <InfoRowData
      key={`${registerId}-0`}
      registerId={registerId}
      leftField={leftField}
      rightField={rightField}
      maxHeightValue={maxHeightValue}
    />
  );

  return (
    <div>
      <ReportSectionTitle title={localize.client_information} />
      <div className="report_section_without_top_border">
        {generateTableData()?.map((row) =>
          generateRowData(
            row.Id,
            row.firstFieldName
              ? { Name: row.firstFieldName, Value: row.firstFieldValue }
              : null,
            row.lastFieldName && {
              Name: row.lastFieldName,
              Value: row.lastFieldValue,
            },
            '30px'
          )
        )}
      </div>
    </div>
  );
}
